<form [formGroup]="formGroup()">
  <app-validated-input
    [label]="translationKey + 'loanProvider'"
    [inputFormControlName]="'name'"
    [inputFormControl]="formGroup().controls.name"
  />

  <app-validated-number-input
    [label]="translationKey + 'interestRate'"
    inputFormControlName="interestRate"
    [inputFormControl]="formGroup().controls.interestRate"
  />

  <app-validated-date-picker
    [label]="translationKey + 'loanExpiration'"
    inputFormControlName="end"
    [inputFormControl]="formGroup().controls.end"
  />

  <app-validated-number-input
    [label]="translationKey + 'applicableReturn'"
    inputFormControlName="applicableReturn"
    [inputFormControl]="formGroup().controls.applicableReturn"
  />
</form>
